module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "pre"
    }
  }, [_vm._v("Key to Symbols")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "alt": "fourstar",
      "src": "OEBPS/images/4star.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("A great film"), _c('br'), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("G, PG, PG-13, R, NC-17")]), _vm._v(": Ratings of the Motion Picture Association of America"), _c('br'), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("G")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Indicates that the movie is suitable for general audiences"), _c('br'), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Suitable for general audiences but parental guidance is suggested"), _c('br'), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG-13")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Recommended for viewers 13 years or above; may contain material inappropriate for younger children"), _c('br'), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Recommended for viewers 17 or older"), _c('br'), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NC-17")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Intended for adults only"), _c('br'), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("141 m.")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Running time"), _c('br'), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2011")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Year of theatrical release")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c858686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792175_epub_pre_r1.vue
// module id = 75
// module chunks = 0